import { yupResolver } from '@hookform/resolvers/yup'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Breadcrumbs, Button, Card, InputAdornment, Link, Paper, Stack, TextField, Typography } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { DateTimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as yup from "yup"
import LoadingUI from '../../comman/LoadingUI'
import NoDataFound from '../../comman/NoDataFound'
import SnackBarUI from '../../comman/SnackBarUI'
import Appbar from '../../components/Appbar'
import DrawerUI from '../../components/Drawer'
import { dateConvert } from '../../helper/dateConverter'
import Body from '../../layout/Body'
import { getPasuedMissionAction } from '../../redux/toolkit/mission/getPasuedMission'
import { liveMissionInBulkAction } from '../../redux/toolkit/mission/liveMissionInBulk'
import { useStyles } from '../../theme/theme'



const breadcrumb = (
    <Stack>
        <Breadcrumbs separator={<NavigateNextIcon sx={{ color: '#fff' }} fontSize="small" />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/'>Home</Link>
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/mission'>Mission</Link>
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/mission/live-bulk-mission'>Live Bulk Mission</Link>
        </Breadcrumbs >
        <Typography variant='h5'>Mission</Typography>
    </Stack >
)

// schema
const missionDetailsSchema = yup.object({
    // hours: yup.string().required(),
    minutes: yup.string().required(),
}).required();



export default function LiveBulkMission() {
    // state
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const getPasuedMissionSelector = useSelector(state => state.getPasuedMission)
    const { data: missionData, loading: missionLoading } = getPasuedMissionSelector

    const liveMissionInBulk = useSelector(state => state.liveMissionInBulk)
    const { status, message } = liveMissionInBulk

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(missionDetailsSchema), defaultValues: {}
    });

    const [pageSize, setPageSize] = useState(25);
    const classes = useStyles();
    const [snack, setSnack] = useState(false)
    const [date, setDate] = useState({ start: null, end: null })
    const [missionList, setMissionList] = useState([])

    const qnsDataGridColumns = [
        {
            field: 's_no',
            headerName: 'S. No.',
            filterable: false,
            flex: 1,
            minWidth: 50,
            headerClassName: 'super-app-theme--header',
            renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1
        },
        {
            field: '_id',
            headerName: 'ID',
            flex: 1,
            minWidth: 170,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'title',
            headerName: 'Title',
            flex: 1,
            minWidth: 170,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'cat_id',
            headerName: 'Category Name',
            flex: 1,
            minWidth: 170,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.cat_id?.cat_name}</Typography>
                )
            },
        },
        {
            field: 'sub_cat_id',
            headerName: 'Sub Category Name',
            flex: 1,
            minWidth: 170,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.sub_cat_id?.sub_cat_name}</Typography>
                )
            },
        },
        {
            field: 'mission',
            headerName: 'Mission',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
        },
    ]

    // fn
    let handleMission = async (data) => {

        // if (new Date(date?.start).getDate() == new Date(date?.end).getDate()) {
        //     return setError('dateError', { type: 'custom', message: 'Start and End date can not be same' });
        // }

        let liveMissionInBulk = await dispatch(liveMissionInBulkAction({
            mission_start_date: dateConvert(date?.start),
            mission_end_date: dateConvert(date?.end),
            mission_ids: missionList,
            minutes: Number(data?.minutes),
        }))
        
        setSnack(true)

        if (liveMissionInBulk?.payload?.status == 200) {
            setTimeout(()=>{

                navigate("/mission")
            },1500)
        }
    }


    // console.log("date --->start", dateConvert(date?.start))
    // console.log("date --->end", dateConvert(date?.end))


    // use effect
    useEffect(() => {
        dispatch(getPasuedMissionAction())
    }, [dispatch])


    return (
        <>
            <Helmet><title>Quick mission | Live Mission</title></Helmet>
            <Appbar breadcrumb={breadcrumb} />
            <DrawerUI />
            <Body>

                <Card>
                    <Typography variant='h5' sx={{ p: 2 }} >Live mission for certain date / time period</Typography>


                    <form onSubmit={handleSubmit(handleMission)}>
                        <Stack sx={{ p: 2 }} spacing={2}>
                            <Stack>
                                <Typography color='primary'>Each Mission Opening Time</Typography>
                                <Stack direction={'row'} spacing={2} sx={{ my: 2 }}>
                                    {/* <TextField type='number'  {...register('hours')} error={errors?.hours?.message} helperText={errors?.hours?.message} fullWidth label='Hours' InputProps={{ endAdornment: <InputAdornment position="end">Minute</InputAdornment>, inputProps: { min: 0, max: 12 } }} /> */}
                                    <TextField type='number' {...register('minutes')} error={errors?.minutes?.message} helperText={errors?.minutes?.message} fullWidth label='Minuts' InputProps={{ endAdornment: <InputAdornment position="end">Minute</InputAdornment>, inputProps: { min: 1, max: 60 } }} />
                                </Stack>
                            </Stack>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Typography color='primary'>Mission Bulk Date Range</Typography>
                                <Stack direction={'row'} spacing={2}>
                                    <DateTimePicker
                                        label="Live Start Date"
                                        value={date?.start}
                                        onChange={(value) => {
                                            // console.log("value", value)
                                            setDate({ ...date, start: value })
                                        }}
                                        minDate={new Date()}
                                        renderInput={(params) => <TextField fullWidth {...params}
                                            helperText={errors?.dateError?.message}
                                            error={errors?.dateError?.message} />}
                                    />
                                    <DateTimePicker
                                        label="Live End Date"
                                        value={date?.end}
                                        minDate={date?.start}
                                        onChange={(value) => {
                                            setDate({ ...date, end: value })
                                        }}
                                        renderInput={(params) => <TextField fullWidth {...params}
                                            error={errors?.dateError?.message}
                                            helperText={errors?.dateError?.message}
                                        />}
                                    />
                                </Stack>
                            </LocalizationProvider>


                        </Stack>

                        <Paper sx={{
                            bgcolor: '#fff',
                            '& .super-app-theme--header': {
                                bgcolor: '#071D45',
                                color: '#fff',
                            },
                        }} elevation={0}>
                            <DataGrid
                                className={classes.root}
                                getRowHeight={() => 'auto'}
                                sx={{ border: 0 }}
                                checkboxSelection
                                autoHeight
                                rows={missionData}
                                columns={qnsDataGridColumns}
                                getRowId={(row) => row._id}
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                pagination
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[25, 50, 100]}
                                disableColumnSelector
                                loading={missionLoading ? <LoadingUI /> : false}
                                onSelectionModelChange={linkedQns => setMissionList(linkedQns)}
                                components={{
                                    NoRowsOverlay: () => <NoDataFound />,
                                    Toolbar: GridToolbar,
                                }}

                            />
                        </Paper>

                        <Stack direction={'row'} spacing={2} sx={{ p: 2 }}>
                            <Button type='submit' variant='contained'>Live Mission</Button>
                            <Button variant='contained' color='error' onClick={() => { navigate("/mission") }}>Back</Button>
                        </Stack>
                    </form>

                </Card>
            </Body>
            {console.log("snack and message",snack,message)}
            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}
